<template>
  <div id="app">
  	<!--<img class="bg" src="assets/bg.png" alt="" />-->
    <!--<router-view/>-->
    <nav-fds></nav-fds>
  </div>
</template>

<script>
  import navfds from './components/navfds/navfds.vue';
export default {
  name: 'App',
  components: {
	    NavFds:navfds
	}
}
</script>

<style>
body{
	margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;/*使低像素图标字体更清晰*/
  -moz-osx-font-smoothing: grayscale;
  background-image: url('assets/images/bg.png'); /*背景图片地址*/
	background-repeat: no-repeat;/*背景图片不重复*/
	background-size: cover;/*背景图片拉伸铺满*/
	width: 100%; /* 宽度为100%；*/
	min-width: 1300px;
	height: 52.5vw; /*原图宽高比为100：93.2，所以高度为整个窗口宽度的93.2%*/
	position: relative;
	margin: 0 auto;
	overflow: hidden;
}
body{
	background-image: url('assets/images/bg2.png');
	background-repeat: repeat;
}
</style>



// WEBPACK FOOTER //
// src/App.vue